'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.default = timerMiddleware;

var _constants = require('../constants/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function timerMiddleware() {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        return function (next) {
            return function (action) {
                if (action.hasOwnProperty('timerState') && action.timerState == 'start') {
                    var timer = new Timer(next, action);
                    timer.start(action.time);
                }

                return next(action);
            };
        };
    };
}

var Timer = function Timer(next, action) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Timer);

    this.start = function (t) {
        _this.time = t;
        setTimeout(_this.change, 1000);
    };

    this.change = function () {
        _this.time--;
        if (_this.time > 0) setTimeout(_this.change, 1000);
        return _this.next((0, _extends3.default)({}, _this.action, { time: _this.time, timerState: 'change' }));
    };

    this.next = next;
    this.action = action;
    this.time = 0;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/timerMiddleware.js
// module id = 1891
// module chunks = 0